import { Injectable } from "@angular/core";
import { DropdownSettingsFactory } from "../dropdown/dropdown-settings.factory";
import { OwnerService } from "../../../services/billing-letter/owner.service";
import { OptionsBilling } from "../../enums/billing-letter/OptionsBilling";
import { DropdownItemFactory } from "../dropdown/dropdown-item.factory";
import { LocalStorage } from "../../wrappers/LocalStorage";
import { CommonHelper } from "../../helpers/CommonHelper";
import { FiltersFactory } from "../filters.factory";
import { ConsultantService } from "../../../services/consultant.service";
import { ConsultantSearch } from "../../../models/ConsultantSearch.model";
import { UserService } from "../../../services/user.service";
import { CompanyService } from "../../../services/billing-letter/company.service";
import { IndustriesService } from '../../../services/industries.service';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';

@Injectable()
export class CostFiltersFactory extends FiltersFactory {
    constructor(
        private localStorage: LocalStorage,
        private ownerService: OwnerService,
        private commonHelper: CommonHelper,
        private optionsBilling: OptionsBilling,
        private companyService: CompanyService,
        private dropdownItemFactory: DropdownItemFactory,
        private dropdownSettingFactory: DropdownSettingsFactory,
        private consultantService: ConsultantService,
        private userService: UserService,
        private industriesService: IndustriesService,
        private excellenceCentersService: ExcellenceCentersService
    ) { super() }

    async build(filters, localStorageFilterKey = 'cost') {

        filters.companyGroups.list = this.dropdownItemFactory.build({ source: await this.companyService.getAllCompanyGroups()});
        filters.owners.list = this.dropdownItemFactory.build({ source: await this.ownerService.getAll() });
        if(filters.consultant){
            let consultantSearch = new ConsultantSearch();
            consultantSearch.onlyActives = false;
            consultantSearch.limit = 9999999;
            filters.consultant.list = this.dropdownItemFactory.build({source: await this.consultantService.searchConsultants(consultantSearch)});
            filters.consultant.options = this.dropdownSettingFactory.build({text:"Consultores"});
        }

        if(filters.responsible){
            filters.responsible.list = this.dropdownItemFactory.build({source:await this.userService.getAllUsersAsResponsibles()});
            filters.responsible.options = this.dropdownSettingFactory.build({text:"Gestores"});
        }

        if(filters.industries){
            filters.industries.list = this.dropdownItemFactory.build({source: await this.industriesService.getAll() });
            filters.industries.options = this.dropdownSettingFactory.build({ text: 'Setores'})
        }

        const centers = await this.excellenceCentersService.getAll();
        if(filters.excellenceCenters){
            filters.excellenceCenters.list = this.dropdownItemFactory.build({source: centers.filter(c => c.type == 1) });
            filters.excellenceCenters.options = this.dropdownSettingFactory.build({ text: 'Centros de Excelência'})
        }

        if(filters.supportCenter){
            filters.supportCenter.list = this.dropdownItemFactory.build({source: centers.filter(c => c.type == 2) });
            filters.supportCenter.options = this.dropdownSettingFactory.build({ text: 'Áreas de Suporte'})
        }

        filters.divisions.list = this.optionsBilling.division;
        filters.status.list = this.optionsBilling.status;

        filters.owners.options = this.dropdownSettingFactory.build({ text: 'Requisitantes' });
        filters.companyGroups.options = this.dropdownSettingFactory.build({ text: 'Grupo de empresa' });
        filters.divisions.options = this.dropdownSettingFactory.build({ text: 'Divisões' });
        filters.status.options = this.dropdownSettingFactory.build({ text: 'Status' });
        filters.clients.options = this.dropdownSettingFactory.build({ text: 'Clientes'})
        filters.subDivision.options = this.dropdownSettingFactory.build({ text: 'Frente de Negócios', groupBy: 'division'})
        filters.projects.options = this.dropdownSettingFactory.build({ text: 'Projetos' })
        const filtersStored = this.localStorage.retrieve(localStorageFilterKey);
        return filtersStored ? this.loadStored(filters, filtersStored) : filters;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/cost/filters.factory.ts